import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolesControlService {

  baseUrl = `${environment.apis.base}/roles`; // URL base para la API de roles

  constructor(private readonly http: HttpClient) { }

  /**
   * Obtiene la lista de roles con paginación opcional.
   */
  datatable(page?: number, options?: any): Observable<any> {
    let httpParams = new HttpParams();

    if (typeof page === 'number') {
      httpParams = httpParams.append('page', page);
    }

    if (options?.key?.trim() !== '') {
      httpParams = httpParams.append('search', options.key);
    }

    return this.http.get<any>(this.baseUrl, { params: httpParams });
  }

  /**
   * Obtiene todos los roles sin paginación.
   */
  getAll(): Promise<any> {
    return this.http.get<any>(this.baseUrl).toPromise();
  }

  /**
   * Obtiene un rol por su ID.
   */
  show(id: number): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<any>(url).toPromise();
  }

  /**
   * Crea o actualiza un rol.
   */
  createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
    let url = this.baseUrl;

    if (id) {
      url += `/${id}`;
      return this.http.put<any>(url, data.value);
    } else {
      return this.http.post<any>(url, data.value);
    }
  }

  /**
   * Elimina un rol por ID.
   */
  delete(id: number): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<any>(url);
  }

  /**
   * Obtiene los permisos asociados a un rol.
   */
  getPermissions(roleId: number): Observable<any> {
    const url = `${this.baseUrl}/${roleId}/permissions`;
    return this.http.get<any>(url);
  }

  /**
   * Asigna permisos a un rol.
   */
  detachPermissions(roleId: number, permissions: number[]): Observable<any> {
    const url = `${this.baseUrl}/${roleId}/permissions`;
    return this.http.post<any>(url, { permissions });
  }

  /**
   * Elimina un permiso específico de un rol.
   */
  detachPermission(roleId: number, permissionId: number): Observable<any> {
    const url = `${this.baseUrl}/${roleId}/permissions/${permissionId}`;
    return this.http.delete<any>(url);
  }
}
